import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
   TableHead, TablePagination, TableRow, Typography,ToggleButton } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import AcountsServices from "../../../Services/MasterBilling/AcountsServices";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
       fontFamily: 'Times New Roman',
    textAlign: 'center',
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Voucher() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red",fontFamily: 'Times New Roman',
  };

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');
  const [Filtereddetails, setFiltereddetails] = useState([]);

  const [voucherval, setvoucherval] = useState({
    voctype: '', oldVoucherType: ''
  });

  const [VoucherType, setVoucherType] = useState([]);
  const [error, setError] = useState(false);
  const [AcSaveDsa, setAcSaveDsa] = useState(false);
  const [AcUpdateDsa, setAcUpdateDsa] = useState(true);
  const [AcDeleteDsa, setAcDeleteDsa] = useState(true);

  const [AcSave, setAcSave] = useState(false);
  const [AcUpdate, setAcUpdate] = useState(false);
  const [AcDelete, setAcDelete] = useState(false);

  const voucher_namehandlechange = (e) => {
    setvoucherval({ ...voucherval, voctype: e.target.value })
  };
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{color:'red'}}/>
  }
  //getData
  const getData = async () => {
    AcountsServices.getVoucherType().then((res) => { setVoucherType(res.data); setFiltereddetails(res.data); })
  }

  useEffect(() => {
    const getData = async () => {
      AcountsServices.getVoucherType().then((res) => { setVoucherType(res.data); setFiltereddetails(res.data); })
    }
    getData();
  }, []);

  //tableClick
  const EditVocherType = (item) => {
    setError(false);
    setAcSaveDsa(true); setAcUpdateDsa(false); setAcDeleteDsa(false);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setvoucherval({ ...voucherval, voctype: item.voucherType, oldVoucherType: item.voucherType });
  }

  //ClickEvent
  const validate = () => {
    if (voucherval.voctype !== '') {
      return true;
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Enter A VocherTypeName..!');
      setError(true);
      document.getElementById('vocherTypeName').focus();
    }
    return false;
  }

  const insertVoucherType = () => {
    if (validate() === true) {
      setAcSaveDsa(true); setAcSave(true);
      let details = { voucherType: voucherval.voctype }
      AcountsServices.insertVoucherType(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage(message);
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      });
    }
  }
  const updateVoucherType = () => {
    if (validate() === true) {
      if (voucherval.oldVoucherType !== '') {
        setAcUpdateDsa(true); setAcUpdate(true);
        let details = { voucherType: voucherval.voctype, oldVoucherType: voucherval.oldVoucherType }
        AcountsServices.updateVoucherType(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage(message);
          } else {
            setOpen(true); setSeverity('error'); setMessage(message);
          } refresh(); getData();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
        });
      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select Printed Type Name From the List..!');
      }
    }
  }
  const deleteVoucherType = () => {
    if (voucherval.oldVoucherType !== '') {
      setAcDeleteDsa(true); setAcDelete(true);
      setalertopen(true)
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Select Voucher Type Name From the List..!');
    }
  }
  const refresh = () => {
    setError(false); setAcSaveDsa(false); setAcUpdateDsa(true); setAcDeleteDsa(true);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setvoucherval({ ...voucherval, voctype: '', oldVoucherType: '' });
    document.getElementById('vocherTypeName').focus();
  }


  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //table search
  const VoucherTypeSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { voucherOnchange(e.target.value) }} placeholder="Search" />
  }
  const voucherOnchange = (searchedVal) => {
    const FilterValues = VoucherType.filter((trns) => {
      return trns.voucherType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(VoucherType)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setvoucherval({ ...voucherval, oldVoucherType: item.voucherType })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    AcountsServices.deleteVoucherType(voucherval.oldVoucherType).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage(message);
      } refresh(); getData();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
    });
    setalertopen(false)
  }
   
  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/Printedtype');
  }
  const ForwordBotton =()=>{
    navigate('/checklistApprovalbMngr');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center><h6 style={{ fontFamily: 'Times New Roman'}}>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px' ,fontFamily: 'Times New Roman'}} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px',fontFamily: 'Times New Roman' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography style={{ fontFamily: 'Times New Roman'}}color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}>
                Voucher Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={5} style={{ marginLeft: "-.3rem" }}>
                  <label style={mystyle1}>VoucherTypeName</label>
                </Col>
                <Col xs={7} style={{ marginLeft: "0.3rem" }}>
                  <Form.Control size="sm" type="text" style={mystyle} value={voucherval.voctype} isInvalid={error}
                    id='vocherTypeName' onChange={voucher_namehandlechange} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" disabled={AcSaveDsa} onClick={insertVoucherType}>
                    {AcSave ? 'Processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" disabled={AcUpdateDsa} onClick={updateVoucherType}>
                    {AcUpdate ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button variant="danger" style={{ fontFamily: 'Times New Roman'}}size="sm" disabled={AcDeleteDsa} onClick={deleteVoucherType}>
                    {AcDelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button variant="secondary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={refresh}>
                    refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1%" }}>
              <ItemPap1>
              <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                  Existing  Voucher Type
                </Typography>
                </Col>
                <Col xs={1}>
                 {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>Voucher Type {VoucherTypeSrch()}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                    {Filtereddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                        <StyledTableRow hover key={item.voucherType} onClick={() => EditVocherType(item)}>
                          <StyledTableCell style={{ width: "1rem",textAlign: 'center'}}>{item.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.voucherType}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                        </StyledTableRow>))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Filtereddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Voucher;
